import { render, staticRenderFns } from "./ClientEditClientCompanyKey.vue?vue&type=template&id=144e20fa"
import script from "./ClientEditClientCompanyKey.vue?vue&type=script&lang=js"
export * from "./ClientEditClientCompanyKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports